import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Award } from "lucide-react";
import { useLocation } from "@/lib/locations";

export const CleanerSpotlight = () => {
  const location = useLocation();
  return (
    <section className="py-24 bg-background">
      <div className="container px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16">
          <Badge variant="secondary" className="mb-4 px-4 py-1 text-sm font-semibold uppercase tracking-wider">
            Excellence in Service
          </Badge>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4">
            Cleaner of the Month
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl">
            Meet the professionals who make Uplevel Cleaning the top choice in {location.name}.
          </p>
        </div>

        <Card className="max-w-5xl mx-auto overflow-hidden border-none shadow-elegant bg-muted/30">
          <CardContent className="p-0">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="relative aspect-square md:aspect-auto">
                <img
                  srcSet="https://vibe.filesafe.space/1776798830316075366/assets/1fcd6660-4eae-48e5-80c0-70cf7bdbb0f0.png?w=400&q=80 400w, https://vibe.filesafe.space/1776798830316075366/assets/1fcd6660-4eae-48e5-80c0-70cf7bdbb0f0.png?w=600&q=80 600w"
                  sizes="(max-width: 768px) 400px, 600px"
                  src="https://vibe.filesafe.space/1776798830316075366/assets/1fcd6660-4eae-48e5-80c0-70cf7bdbb0f0.png?w=600&q=80"
                  alt="Maria S. - Top Rated Uplevel Cleaning Professional"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                  width="600"
                  height="600"
                />
                <div className="absolute top-6 left-6">
                  <Badge className="bg-primary text-primary-foreground text-sm py-2 px-4 shadow-lg border-none">
                    <Award className="w-4 h-4 mr-2" />
                    Top Rated Professional
                  </Badge>
                </div>
              </div>

              <div className="p-8 md:p-12 flex flex-col justify-center">
                <div className="mb-6">
                  <h3 className="text-3xl font-bold mb-2">Maria S.</h3>
                  <p className="text-primary font-semibold text-lg">Senior Cleaning Specialist</p>
                </div>


                <div className="relative">
                  <span className="absolute -top-4 -left-4 text-primary/20 text-6xl font-serif">"</span>
                  <p className="text-lg italic text-muted-foreground relative z-10">
                    Maria is known for her incredible attention to detail and her warm personality. She's a favorite among our {location.name} clients! She truly embodies the Uplevel standard.
                  </p>
                </div>

                <div className="mt-10 pt-8 border-t border-border/50">
                  <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider mb-2">Favorite Cleaning Task</p>
                  <p className="text-foreground font-semibold">Kitchen Deep Cleans & Organization</p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
